import script from "./breadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./breadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=d58cff12&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\riverside\\project\\mall\\skill-supply\\skill-supply-mall-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d58cff12"]])

export default __exports__